import { useSelector } from 'react-redux'

import {
  useGetRecipesForCollectionId,
  useAlternativeOptions,
  RecipeCoreId,
  CollectionUUID,
} from '@library/menu-service'

import { useCollection } from 'hooks/menu-collections/useCollection'
import { getSelectedRecipeVariants } from 'routes/Menu/selectors/variants'

export const useCollectionRecipes = (collectionId: CollectionUUID) => {
  const selectedVariants = useSelector(getSelectedRecipeVariants)
  const collection = useCollection(collectionId)

  return useGetRecipesForCollectionId(selectedVariants[collectionId] || {}, collection)
}

export const useRecipeOptions = (collectionId: CollectionUUID, recipeId: RecipeCoreId) => {
  const collection = useCollection(collectionId)

  return useAlternativeOptions(collection, recipeId)
}
